import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import {
  ListPanel,
  DescriptionBox,
  ZeroState,
  getFormattedDateTime,
} from 'ecs-react-components/dist/index.es';
import {
  loadTestResults,
  loadTestResultDetails,
  loadNewTestResultsCount,
  testResultRequestedForPrinting,
} from '../../redux/modules/test-results/test-results-middleware';
import * as actions from '../../redux/modules/test-results/test-results-action-creators';
import { TestResultDetails } from './TestResultDetails';
import { messages } from './TestResults.i18n';
import TestResultsFilters from './TestResultsFilters';
import Header from '../../components/Header/Header';
import { generateListItems } from './ListItemsConfig';
import LoadingIndicatorContainer from '../LoadingIndicatorContainer';

class TestResults extends React.Component {
  constructor(props) {
    super(props);

    this.listItems = [];
  }

  UNSAFE_componentWillMount() {
    this.listItems = generateListItems(this.props.testResults, this.props.language);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.listItems = generateListItems(nextProps.testResults, this.props.language);
  }

  componentDidUpdate() {
    const viewPane = this.viewPane;
    if (viewPane) {
      viewPane.scrollTop = 0;
    }
  }

  getDescriptionBoxContent() {
    const {
      language,
      testResult: {
        startDate,
        requestingPhysician,
        labName,
        labAddress,
        noteToPatient,
      },
    } = this.props;
    const dateParts = getFormattedDateTime(startDate, startDate, language);
    return (
      <div>
        <p id="test_procedure_date_collected">
          <FormattedMessage { ...messages.page.dateCollected } />
          {dateParts.datePart}
        </p>
        <p id="test_procedure_ordered_by">
          <FormattedMessage { ...messages.page.orderedBy } />
          {requestingPhysician}
        </p>
        <p id="test_procedure_lab">
          <FormattedMessage { ...messages.page.lab } />
          {labName} {labAddress}
        </p>
        <br />
        {
          noteToPatient ?
            <p id="test_procedure_remarks">
              <FormattedMessage { ...messages.page.remarks } />
              {noteToPatient}
            </p>
            : ''
        }
      </div>);
  }

  pdfLoadCallback = (downloadedFile) => {
    // convert downloaded data to a Blob
    const blob = new Blob([downloadedFile.data], { type: 'application/pdf' });

    // IE doesn't allow using a blob object directly as link href
    // instead it is necessary to use msSaveOrOpenBlob
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blob, 'TestResults.pdf');
      return;
    }

    const newWin = window.open('about:blank', '_blank');

    // create an object URL from the Blob
    const URL = window.URL || window.webkitURL;
    const downloadUrl = URL.createObjectURL(blob);

    newWin.location.replace(downloadUrl);

    // cleanup: remove element and revoke object URL
    const waitUntilCloses = setInterval(() => {
      if (newWin.closed) {
        URL.revokeObjectURL(downloadUrl);
        clearInterval(waitUntilCloses);
      }
    }, 1000);
  }

  printHandler = () => {
    const { patientId, testResult } = this.props;
    this.props.dispatch(
      testResultRequestedForPrinting(patientId, testResult.labResultId, this.pdfLoadCallback)
    );
  }

  handleListItemClick = (index) => {
    this.props.dispatch(actions.selectedTestResultChanged(this.listItems[index].itemId));

    this.props.dispatch(loadTestResultDetails(this.props.patientId, this.listItems[index].itemId)).then(() => {
      // Make this call so that the 'isNew' badge is updated.
      this.props.dispatch(loadTestResults(this.props.patientId));
      // Make this call so the total number of 'New' test results is updated.
      this.props.dispatch(loadNewTestResultsCount(this.props.patientId));
    });
  }

  renderTestResultDetails(labResultGroups) {
    return (
      <div
        className="view-pane"
        ref={ (divViewPane) => { this.viewPane = divViewPane; } }
      >
        <DescriptionBox
          content={this.getDescriptionBoxContent()}
          showPrintButton
          printClickHandler={this.printHandler}
        />
        {labResultGroups.map((group) => (

          <TestResultDetails groupDisplayName={group.groupDisplayName}
            testResultDetails={group.testResultDetails}
            key={group.testResultGroupId}
          />))}
      </div>
    );
  }

  renderZeroStateMessagesContent() {
    return (
      <ZeroState
        zeroStateMessage={ <FormattedMessage { ...messages.page.zeroStateMessage } /> }
        stateIconCss="fa-regular fa-file-lines"
        ref={ (divViewPane) => { this.viewPane = divViewPane; } }
      />
    );
  }

  renderLeftContentPane() {
    if (this.listItems && this.listItems.length > 0) {
      return (
        <ListPanel
          items={this.listItems}
          title={messages.listPanel.title}
          handleListItemClick={this.handleListItemClick}
          selectedIndex={ this.props.selectedTestResultIndex }
          wrapperClassName="col-lg-4 custom-list-wrapper"
        />
      );
    }

    return (
      <ZeroState
        zeroStateMessage={ <FormattedMessage { ...messages.page.zeroStateMessage } /> }
        stateIconCss="fa-regular fa-file-lines"
      />
    );
  }

  renderMainContentPane() {
    const { labResultGroups } = this.props;

    return (
        <div className="col-lg-8 d-none d-lg-block border border-secondary-subtle p-2">
          {
            labResultGroups.length > 0 ?
              this.renderTestResultDetails(labResultGroups) :
              this.renderZeroStateMessagesContent()
          }
        </div>
    );
  }

  renderHeaderPane() {
    const { badgeNumber } = this.props;

    return (
      <Header headerTitle={<FormattedMessage { ...messages.page.title } /> }
        badgeNumber={badgeNumber}
        headerClassName="mb-3"
      />
    );
  }

  render() {
    return (
      <div className="row" id="test-results-content">
        <div className="col">
          { this.renderHeaderPane() }
          <TestResultsFilters
            filteredRows={
              this.props.testResults ?
                this.props.testResults.filter((value) => !value.isFiltered).length :
                0
            }
            allRows={ this.props.testResults.length || 0 }
          />
          <LoadingIndicatorContainer loadingKey="TestResults" >
            <div className="row g-0">
              { this.renderLeftContentPane() }
              {
                this.listItems && this.listItems.length > 0 ?
                  this.renderMainContentPane() :
                  null
              }
            </div>
          </LoadingIndicatorContainer>
        </div>
      </div>
    );
  }
}

TestResults.propTypes = {
  dispatch: PropTypes.func,
  patientId: PropTypes.string,
  testResults: PropTypes.array,
  testResult: PropTypes.object,
  badgeNumber: PropTypes.number,
  selectedTestResultIndex: PropTypes.string,
  labResultGroups: PropTypes.array,
  language: PropTypes.string,
};

const mapStateToProps = (state) => ({
  patientId: state.profile.patient.patientId,
  testResults: state.testResults.results,
  testResult: state.testResults.selectedTestResult,
  labResultGroups: state.testResults.selectedTestResult.labResultGroups,
  badgeNumber: state.testResults.notReviewedTestResultsCount,
  selectedTestResultIndex: state.testResults.selectedTestResultIndex,
  language: state.language.languageCode,
});

export default connect(mapStateToProps)(TestResults);